import React, { useEffect } from 'react';
import BlogPost from '../components/blogdetails/BlogPost'
import BlogDetBread from '../components/blogdetails/BlogDetBread'

function BlogDetailsPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  
  return (
    
        <main>
        
         <BlogDetBread/> 
          <BlogPost/>
        </main>

  )
}

export default BlogDetailsPage;
